
import Vue from 'vue';
import ViewService from '@/services/ViewService';
import { extractErrorMessage } from '@/utils/Util';

type AlertType = 'success' | 'info' | 'warning' | 'error';

export default Vue.extend({
  name: 'ViewDeleteDialog',

  props: {
    view: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    localDialog: false,
    loading: false,

    alertVisible: false,
    alertType: 'error' as AlertType,
    alertText: '',
  }),

  computed: {
    currentTenantUuid(): string {
      return (this as any).$store.state.session.selectedTenant.uuid;
    },
  },

  methods: {
    resetAlert() {
      this.alertVisible = false;
      this.alertText = '';
      this.alertType = 'error';
    },

    dismiss() {
      if (this.loading) return;
      this.resetAlert();
      this.localDialog = false;
    },

    confirmDelete() {
      this.loading = true;
      this.resetAlert();

      ViewService.delete(this.currentTenantUuid, (this.view as any).uuid)
        .then(() => {
          this.alertType = 'success';
          this.alertText =
            (this.$t('view.successDelete') as any) ||
            'View deleted successfully.';
          this.alertVisible = true;

          setTimeout(() => {
            this.$emit('delete', this.view);
            this.dismiss();
          }, 2000);
        })
        .catch((error: any) => {
          this.alertType = 'error';
          const base = (this.$t('view.errorDelete') as any) || 'Delete failed.';
          this.alertText = String(base) + ' ' + extractErrorMessage(error);
          this.alertVisible = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
